import { CommentArrowRightIcon } from './CommentArrowRightIcon';

/**
 * author: Michael Irigoyen
 * id 256DE915-25D5-4777-AA1A-A432ABB6E039
 * name comment-arrow-right
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-arrow-right.svg
 * tags
 */
export const CommentNextIcon = CommentArrowRightIcon;
export default CommentNextIcon